import * as yup from "yup";

import i18n from "@/i18n";
import { validateBankAccount } from "@/validations";

export const financeFormValidation = (): yup.AnyObjectSchema =>
    yup.object({
        "bankAccount-number": yup
            .string()
            .requiredIf("bankAccount-type")
            .test("accountNumber", i18n.t("Validations.Format"), function testAccountNumber() {
                const type = this.parent["bankAccount-type"];
                const number = this.parent["bankAccount-number"];
                return validateBankAccount(type, number);
            }),
    });
